import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {attachSwalFeedback} from '../../utils/action-feedback.js';

attachSwalFeedback(Swal);
const MySwal = withReactContent(Swal);

export default MySwal;